<template>
  <div class="chat-history-page">
    <side-sessions @selectSession="selectedSession = $event"/>
    <single-session-data :selected-session="selectedSession" v-if="selectedSession._id"/>
    <attributes-list :selected-session="selectedSession"/>
  </div>
</template>

<script>
  import sideSessions from "../components/chatHistoryNew/sessionsFilter/sideSessions";
  import singleSessionData from "../components/chatHistoryNew/singleSession/singleSessionData";
  import attributesList from "../components/chatHistoryNew/sessionAttributes/attributesList";
  export default {
    name: "chat-histroy-new",
    components: {
      sideSessions,
      singleSessionData,
      attributesList
    },
    data() {
      return {
        selectedSession: {}
      }
    },
  }
</script>

<style scoped>

</style>
